import { ComponentPropsWithoutRef, FC } from 'react';
import { Button, Icon } from '@sravni/react-design-system';
import { ArrowLeft } from '@sravni/react-icons';
import cn from 'classnames';
import styles from './styles.module.scss';

type StepButtonsProps = ComponentPropsWithoutRef<'div'> & {
    onContinueButtonClick?: () => void;
    continueButtonText?: string;
    continueButtonDisabled?: boolean;
    onReturnButtonClick?: () => void;
};

export const StepButtons: FC<StepButtonsProps> = (props) => {
    const {
        continueButtonText = 'Продолжить',
        onContinueButtonClick,
        continueButtonDisabled,
        onReturnButtonClick,
        className,
    } = props;
    return (
        <div className={cn(styles['step-buttons'], className)}>
            {onReturnButtonClick && (
                <Button
                    type="button"
                    variant="primary"
                    size={52}
                    onClick={onReturnButtonClick}
                    className={styles['return-button']}>
                    <Icon size={20} icon={<ArrowLeft />} />
                </Button>
            )}
            <Button
                variant="primary"
                type="submit"
                size={52}
                disabled={continueButtonDisabled}
                onClick={onContinueButtonClick}
                className={styles['continue-button']}>
                {continueButtonText}
            </Button>
        </div>
    );
};
